var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSelectTool = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 34
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#545454",
  d: "M23.999 19.571H20.27l1.962 4.78a.653.653 0 0 1-.332.844l-1.728.754a.62.62 0 0 1-.82-.342l-1.866-4.54-3.047 3.134c-.406.418-1.064.096-1.064-.452V8.643c0-.576.7-.858 1.064-.452l9.999 10.284c.404.394.106 1.096-.439 1.096",
  fillRule: "evenodd"
})));
export default SvgSelectTool;